export default __webpack_public_path__ + "static/media/Certificate.b07a58a6.pdf";